import { Link } from 'react-router-dom';

export default function BusinessCase() {
  return (
    <div className="content">
      {/* Banner */}
      <div className="d-flex align-items-center gap-3 p-3 rounded-4 flex-wrap" style={{ background: 'linear-gradient(135deg,#0c2f45,#1a5e7d)' }}>
        <div className="fo-banner-ico">💼</div>
        <div className="flex-grow-1 text-white" style={{ fontSize: '12.5px', lineHeight: 1.5, opacity: .92 }}>
          <strong style={{ color: '#7DD6F0' }}>Nova generates and maintains BCs end-to-end.</strong> When Farminform, CBG or NHG data updates, Nova auto-recalculates and flags. Each step requires your sign-off before the next unlocks.
        </div>
        <button className="btn btn-s btn-sm" style={{ background: 'rgba(255,255,255,.12)', border: '1px solid rgba(255,255,255,.2)', color: '#fff' }}>+ New BC</button>
      </div>

      {/* BC cards grid */}
      <div className="row g-3">
        {/* Valsartan BC */}
        <div className="col-md-6 col-xl-4">
          <Link to="/bc/editor" className="card p-3 text-decoration-none d-block h-100 position-relative overflow-hidden" style={{ transition: 'all .18s' }}>
            <div className="d-flex align-items-start gap-2 mb-2">
              <div style={{ width: 36, height: 36, borderRadius: 10, background: 'var(--green2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 17, flexShrink: 0 }}>💊</div>
              <div className="flex-grow-1">
                <div style={{ fontSize: 13, fontWeight: 700, fontFamily: "'Syne',sans-serif", color: 'var(--navy)' }}>Valsartan 160 mg</div>
                <div style={{ fontSize: '10.5px', color: 'var(--t3)' }}>Sandoz NL · Cardiovascular</div>
              </div>
              <span className="pill p-g">Active BC</span>
            </div>
            <div className="p-2 rounded-2 mb-2" style={{ background: 'var(--amber2)', fontSize: 11, color: 'var(--amber)' }}>
              ✦ Nova updated: +€180K Y1 from new Farminform data
            </div>
            <div className="row g-2 mb-2">
              <div className="col-6">
                <div className="p-2 rounded-2" style={{ background: 'var(--surf)' }}>
                  <div style={{ fontSize: 9, color: 'var(--t3)', textTransform: 'uppercase' }}>Est. Y1 Revenue</div>
                  <div style={{ fontSize: 17, fontWeight: 800, color: 'var(--green)', fontFamily: "'Syne',sans-serif" }}>€2.6M</div>
                </div>
              </div>
              <div className="col-6">
                <div className="p-2 rounded-2" style={{ background: 'var(--surf)' }}>
                  <div style={{ fontSize: 9, color: 'var(--t3)', textTransform: 'uppercase' }}>4Y Total</div>
                  <div style={{ fontSize: 17, fontWeight: 800, color: 'var(--navy)', fontFamily: "'Syne',sans-serif" }}>€14.1M</div>
                </div>
              </div>
            </div>
            <div className="d-flex flex-wrap gap-1">
              <span className="pill p-g">✓ GO</span>
              <span className="ai-badge">✦ Step 4/5</span>
              <span className="pill p-a">Awaiting MD</span>
            </div>
            <div style={{ height: 3, position: 'absolute', bottom: 0, left: 0, width: '80%', background: 'var(--teal)', borderRadius: '0 2px 2px 0' }} />
          </Link>
        </div>

        {/* Losartan BC */}
        <div className="col-md-6 col-xl-4">
          <div className="card p-3 h-100 position-relative overflow-hidden" style={{ cursor: 'pointer' }}>
            <div className="d-flex align-items-start gap-2 mb-2">
              <div style={{ width: 36, height: 36, borderRadius: 10, background: 'var(--teal3)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 17, flexShrink: 0 }}>💊</div>
              <div className="flex-grow-1">
                <div style={{ fontSize: 13, fontWeight: 700, fontFamily: "'Syne',sans-serif" }}>Losartan 50 mg</div>
                <div style={{ fontSize: '10.5px', color: 'var(--t3)' }}>Pharmasupply GmbH · Cardiovascular</div>
              </div>
              <span className="pill p-t">Draft</span>
            </div>
            <div className="row g-2 mb-2">
              <div className="col-6">
                <div className="p-2 rounded-2" style={{ background: 'var(--surf)' }}>
                  <div style={{ fontSize: 9, color: 'var(--t3)', textTransform: 'uppercase' }}>Est. Y1</div>
                  <div style={{ fontSize: 17, fontWeight: 800, color: 'var(--teal)', fontFamily: "'Syne',sans-serif" }}>€1.8M</div>
                </div>
              </div>
              <div className="col-6">
                <div className="p-2 rounded-2" style={{ background: 'var(--surf)' }}>
                  <div style={{ fontSize: 9, color: 'var(--t3)', textTransform: 'uppercase' }}>Status</div>
                  <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--amber)', marginTop: 3 }}>RA input pending</div>
                </div>
              </div>
            </div>
            <div className="d-flex gap-1"><span className="ai-badge">✦ Step 2/5</span><span className="pill p-a">Needs RA input</span></div>
            <div style={{ height: 3, position: 'absolute', bottom: 0, left: 0, width: '40%', background: 'var(--teal)', borderRadius: '0 2px 2px 0' }} />
          </div>
        </div>

        {/* New BC card */}
        <div className="col-md-6 col-xl-4">
          <div className="card d-flex align-items-center justify-content-center flex-column gap-2 h-100" style={{ border: '2px dashed var(--brd)', background: 'var(--surf)', cursor: 'pointer', minHeight: 180, color: 'var(--t3)' }}>
            <div style={{ fontSize: 28 }}>+</div>
            <div style={{ fontSize: 13, fontWeight: 600 }}>New Business Case</div>
            <div style={{ fontSize: 11 }}>Nova generates in seconds</div>
          </div>
        </div>
      </div>
    </div>
  );
}
